import variantFragment from '../fragments/variantWithProduct';

/** Admin query */
export const getProductVariantsByIdsQuery = /* GraphQL */ `
  query getProductVariantsById($query: String, $countryCode: CountryCode = US) {
    productVariants(first: 100, query: $query) {
      edges {
        node {
          ...variant
        }
      }
    }
  }
  ${variantFragment}
`;

/** Storefront query for single variant */
export const getProductVariantQuery = /* GraphQL */ `
  query getProductVariant($id: ID!) {
    node(id: $id) {
      ... on ProductVariant {
        id
        title
        price {
          amount
          currencyCode
        }
        availableForSale
        selectedOptions {
          name
          value
        }
        product {
          title
          handle
          metafields(identifiers: [{ namespace: "custom", key: "other_metafield" }]) {
            id
            key
            namespace
            value
            type
          }
        }
      }
    }
  }
`;
